/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {
    CANCEL: 'Abbrechen',
    CONFIRM: 'Bestätigen',
    CONFIRM_POLL_RESPONSE: 'Antwort bestätigen',
    CONTINUE: 'Weiter',
    COPY: 'Kopie',
    DELETE: 'Löschen',
    DELETE_MESSAGE: 'Nachricht löschen',
    EDIT: 'Bearbeiten',
    FINISH: 'Beenden',
    HIDE_ANSWERS: 'Antworten ausblenden',
    LETS_GET_STARTED: 'Klar, lass uns loslegen.',
    MARK_AS_UNREAD: 'Als ungelesen markieren',
    REPLY: 'Antworten',
    SEE_ANSWERS: 'Antworten anzeigen',
    START_SURVEY: 'Umfrage starten'
  },
  ERROR: {
    ASSET_SIZE_EXCEEDED: 'Die maximale Dateigröße beträgt {size}MB',
    CLASSIFICATION_ALREADY_IN_USE:
      'Die Umfrage ist abgelaufen, da es bereits eine Kampagne für diese Kategorie gibt.',
    ERROR_CREATING_NEW_SUGGESTION: 'Fehler beim Erstellen eines neuen Angebots',
    ERROR_SAVING_PRODUCT_REVIEW: 'Problem beim Speichern der Produktbewertung',
    ERROR_SENDING_MESSAGE: 'Fehler beim Senden der Nachricht',
    ERROR_SUBMITTING_SURVEY: 'Fehler beim Einreichen der Umfrage',
    IMAGE_SIZE_EXCEEDED: 'Die maximale Bildgröße beträgt {size}MB',
    MESSAGE_ALREADY_READ:
      'Diese Nachricht kann nicht mehr bearbeitet werden, da sie bereits gelesen wurde.',
    UPLOADED_ASSETS_EXCEED: 'Die maximale Anzahl an Dateien beträgt {limit}',
    VIDEO_SIZE_EXCEEDED: 'Die maximale Videogröße beträgt {size}MB'
  },
  HEADER: {},
  LABEL: {
    ACTIONS: 'Aktionen',
    ADDITIONAL_COMMENTS_QUESTION: 'Hast du noch was zu sagen?',
    ANSWERED_ON: 'Beantwortet am {date}',
    CONTACT_OWNER:
      'Es ist ein Fehler aufgetreten. Bitte kontaktieren Sie Ihren Vorgesetzten',
    CREATE_NEW_CAMPAIGN_SUGGESTION:
      'Klicke hier, um ein neues Angebot zu erstellen',
    EDITED: 'Bearbeitet',
    EXPIRED_ON: 'Ist abgelaufen {date}',
    LAST_READ: 'Zuletzt gelesen',
    POLL_CAMPAIGN_EXPIRED: 'ℹ️ Abgelaufenes Angebot',
    POLL_CAMPAIGN_FOOTER:
      'ℹ️ Mit deiner Zustimmung wird die Kampagne erstellt und startet morgen.\nDu erhältst morgen außerdem die Nachricht mit dem Poster zum Teilen.\nDieses Angebot ist 3 Tage verfügbar.',
    QUANTITY: 'Menge',
    REACT: 'Reagieren',
    REACTIONS: 'Reaktionen',
    RESPOND_BY: 'Antwort bis {date}',
    SEE_PRODUCTS: 'Produkte ansehen',
    SEEN: 'Gesehen',
    SELECT_ADDRESS: 'Adresse auswählen',
    SELECT_ONE_OPTION: 'Wähle eine Option aus',
    SELECT_ONE_OR_MORE_OPTION: 'Wähle eine oder mehrere Optionen aus',
    SENT: 'Gesendet',
    SWIPE_TO_CANCEL: 'Wischen zum Abbrechen',
    TYPE_NEW_MESSAGE: 'Schreibe eine neue Nachricht',
    VOICE_MESSAGE: 'Sprachnachricht'
  },
  SENTENCE: {
    CONFIRM_POLL_INTERNAL_ORDER:
      'Diese Aktion bestätigt die Bestellung. Die Antwort kann anschließend nicht mehr geändert werden. Möchten Sie fortfahren?',
    DELETE_MESSAGE_CONFIRM:
      'Bist du sicher, dass du diese Nachricht löschen möchtest?',
    GIVE_OPINION_ABOUT_PRODUCT:
      'Kannst du uns deine Meinung zu diesem Produkt sagen?',
    MESSAGE_DELETED: 'Diese Nachricht wurde gelöscht'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
